"use client";

import Link from "next/link";
import Image from "next/image";
import dynamic from "next/dynamic";
import { Stack, Typography } from "@mui/material";
import arrow from "@/assets/images/icons/arrow.webp"
import SideTabbedButton from "@/components/generic/SideTabbedButton";

const PortfolioSlider = dynamic(() => import("@/components/home/portfolioSlider"), { ssr: false });

const OurPortfolio = () => {
    return (
        <Stack
            width={"100%"}
            height={"100%"}
            alignItems={"center"}
            justifyContent={"center"}
            position={"relative"}
            overflow={"hidden"}
            paddingX={{ xs: 2, lg: 10 }}
            mt={{ xs: -4, md: -20, lg: -22, xl: -14 }}
            pb={{xs:0, lg:6}}
            gap={{ xs: 1, lg: 8 }}
        >
            <Stack
                width={"100%"}
                height={"100%"}
                direction={{ xs: "column", lg: "row" }}
                alignItems={"center"}
                justifyContent={"start"}
                position={"relative"}
                gap={2}
                zIndex={3}
                paddingX={0.9}
            >
                <Typography variant="h2" fontWeight={400} fontSize={{ xs: "1.75rem !important", lg: "2.75rem !important" }} className="chno">
                    Our Portfolio
                </Typography>
                <Stack mt={1} display={{ xs: "none", lg: "block" }}>
                    <Link href="/portfolio" style={{ textDecoration: 'none', display: 'block', width: '100%' }}>
                        <SideTabbedButton fullWidth paddingX={18} hoverShiftX={1.5} hoverShiftY={-1}>
                            <div className="flex items-center justify-center gap-1">
                                <Typography component="span" variant="h6" marginRight={1}>
                                    All projects
                                </Typography>
                                <span className="arrow-clip">
                                    <span className="arrow-slide">
                                        <Image src={arrow} alt="arrow animation" width={20} height={20} style={{ display: "block" }} />
                                    </span>
                                </span>
                            </div>
                        </SideTabbedButton>
                    </Link>
                </Stack>
            </Stack>
            <Stack
                width={"100%"}
                alignItems={"center"}
                justifyContent={"center"}
                position={"relative"}
                zIndex={3}
            >
                <Stack width={"100%"} alignItems={"stretch"} justifyContent={"center"}>
                    <PortfolioSlider />
                </Stack>
            </Stack>
        </Stack>
    )
}

export default OurPortfolio;
